define('../src/journeys/j2-register/j2-register',['jquery', 'lib/utils'], function($, utils) {

    'use strict';

    var J2_REG = function($journey) {

        this.$journey = $journey;

        return this;
    };

    J2_REG.prototype.init = function() {
        var _this = this;

        this.$journey.find('.j2-register--radiocard').each(function (){
            $(this).off('click.j2').on('click.j2', function () {
                _this.$journey.find('.j2-register--radiocard.checked').removeClass('checked');
                $(this).addClass('checked');
            });
        });
    };

    return J2_REG;
});

